export default function currencyFormatter(value: number): string {
    if(isNaN(value))
        return "€ ";
    return "€ " + value?.toLocaleString('en-US', { useGrouping: true });
}
export function currencyToNumber(value: string): number {
    return parseFloat(value.replace("€ ", "").replace(",",""));
}